
export default {
  props: {
    counter: {
      type: Number,
      default: 500
    }
  },
  methods: {
    emitClick() {
      this.$emit('emitClick', true)
    }
  }
}
